import { IonCol, IonGrid, IonRow } from "@ionic/react";
import React, { FC } from "react";
import IncentiveResults from "./IncentiveForecastComponents/IncentiveResults";
import IncentiveDataTable from "./IncentiveForecastComponents/IncentiveDataTable";

interface IProps {
    building:string | null
};


const IncentiveForecast:FC<IProps> = (props) => {    
    return <IonGrid>
        <IonRow>
            <IonCol size="12" sizeLg="7">
                <h5>kWh Data:</h5>
                <IncentiveDataTable building={props.building!}  type="kwh"/>
                <h5>Therm Data:</h5>
                <IncentiveDataTable building={props.building!}  type="therms"/>
            </IonCol>
            <IonCol size="12" sizeLg="5">
                <h5>Results:</h5>
                <IncentiveResults building={props.building!} />
            </IonCol>
        </IonRow>
    </IonGrid>
};

export default IncentiveForecast;